import { all, call, fork, put, select, takeLatest, takeLeading } from 'redux-saga/effects'
import * as types from 'store/types'
import * as apis from 'store/apis'
import {
  getActiveSubscription_action,
  fetchTeams_action,
  updateMembership_action,
  getCategories_action,
  getDrafts_action,
  getAdminPageTemplates_action,
  getTeamPageTemplates_action,
  addNotifications_action,
  getCompany_action,
  setCompany_action,
  setMembers_action,
  setRecentActivities_action,
  setStripeCustomer_action,
  toggleCompanyLoading_action,
  getUserProfile_action,
  getPrivateAndFavoriteContents_action,
  setChangeLogs_action
} from 'store/actions'
import { getCompany_storage, setCompany_storage } from 'utils/storageUtils'
import { history } from 'store/store'
import { addTrafficSource, consoleLog, handleApiError } from 'utils/helpers'

export const getCurrentRoute = (state) => state.router?.location?.pathname

function* getCompany_saga() {
  try {
    yield put(toggleCompanyLoading_action(true))
    const result = yield call(apis.getCompany_api)

    // Company, Notifications, Recent-activities
    yield put(setCompany_action(result))
    setCompany_storage({ ...result.company, members: [], tags: [] })

    yield put(toggleCompanyLoading_action(false))
    if (!result.company.stripe_id) {
      const customer = yield call(apis.createStripeCustomerId_api)
      yield put(setStripeCustomer_action(customer))
    }
  } catch (error) {
    handleApiError(error)
  }
}
function* getNotifications_saga({ filters, resolve, reject }) {
  try {
    const pageNo = yield select((state) => {
      return state.company.notifications[filters.type].pageNo
    })
    const total = yield select((state) => state.company.notifications[filters.type].total)
    const data = yield select((state) => state.company.notifications[filters.type].data)
    if (data.length === 0 || total > data.length) {
      const result = yield call(apis.getNotifications_api, { ...filters, pageNo: data.length === 0 ? 1 : pageNo + 1 })
      yield put(addNotifications_action(result))
    }
    resolve && resolve()
  } catch (error) {
    handleApiError(error)
    reject && reject()
  }
}
function* getRecentActivities_saga() {
  try {
    const result = yield call(apis.getRecentActivities_api)
    yield put(setRecentActivities_action(result))
  } catch (error) {
    consoleLog(error)
  }
}
function* getMembers_saga() {
  try {
    const result = yield call(apis.getMembers_api)
    const company = getCompany_storage()
    company.members = result
    setCompany_storage(company)
    yield put(setMembers_action(result))
  } catch (error) {
    handleApiError(error)
  }
}
function* createCompany_saga({ data, resolve, reject }) {
  try {
    yield put(toggleCompanyLoading_action(true))
    const company = yield call(apis.createCompany_api, data)
    yield put(getUserProfile_action())
    yield put(updateMembership_action(company.membership))
    yield put(getCompany_action())
    yield put(getCategories_action())
    yield put(getPrivateAndFavoriteContents_action({ type: 'page' }))
    yield put(getPrivateAndFavoriteContents_action({ type: 'response' }))
    yield put(getDrafts_action())
    yield put(getAdminPageTemplates_action())
    yield put(getTeamPageTemplates_action())
    yield put(fetchTeams_action())
    yield put(getActiveSubscription_action())
    addTrafficSource('onboarding', company.name, company.membership?.email)

    const appversion = yield call(apis.getAppVersion_api)
    yield put(setChangeLogs_action(appversion))

    const pathname = yield select(getCurrentRoute)
    if (!pathname.includes('onboarding')) {
      history.push('/')
    }
    resolve && resolve()
  } catch (error) {
    handleApiError(error)
    reject && reject()
  }
}

export function* watchSagas() {
  yield takeLatest(types.GET_COMPANY, getCompany_saga)
  yield takeLeading(types.CREATE_COMPANY, createCompany_saga)
  yield takeLeading(types.GET_NOTIFICATIONS, getNotifications_saga)
  yield takeLeading(types.GET_RECENT_ACTIVITIES, getRecentActivities_saga)
  yield takeLeading(types.GET_MEMBERS, getMembers_saga)
}

export default function* companySaga() {
  yield all([fork(watchSagas)])
}
